import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './features/auth/AuthContext.js';
import { AppRoutes } from './routes.js';

/**
 * Query defaults tuned for rural mobile networks (NFR-2).
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry a flaky connection, but never retry an auth or permission
      // failure — the interceptor already handled the refresh, and repeating
      // a 403 just wastes a partner's data allowance.
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } }).response?.status;
        if (status === 401 || status === 403 || status === 422) return false;
        return failureCount < 3;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 15_000),
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
